var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(-3.5 -8.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152270",
    "data-name": "Path 152270",
    d: "M31.5,22.5v2.933c0,.81-1.343,1.467-3,1.467H7.5c-1.657,0-3-.657-3-1.467V22.5",
    transform: "translate(0 4.6)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152271",
    "data-name": "Path 152271",
    d: "M10.5,15,18,22.5,25.5,15",
    transform: "translate(0 5)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152272",
    "data-name": "Path 152272",
    d: "M18,22.5V4.5",
    transform: "translate(0 5)",
    fill: "none",
    stroke: "#00aff1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.fe95585ff6cec005c6e2ae7b00279fbb.svg";
export { ForwardRef as ReactComponent };